import i18next from 'i18next'
import { IntersectionalityFilterProps } from '@diversioteam/diversio-ds'

import { GetCompanyProfilesOptionsResponse } from 'api/actions/analyze/companyProfiles/companyProfilesActions.types'

export const translatedFilters = (filters: GetCompanyProfilesOptionsResponse['filters']) => {
    return filters.map((filter) => {
        return {
            ...filter,
            key: filter.name,
            name: i18next.t(`MISC.${filter.name.toUpperCase()}`, filter.name),
        }
    })
}

export const translatedProfiles = (profiles: IntersectionalityFilterProps['profiles']) => {
    return profiles.map((profile) => {
        if (!profile.filters) {
            return profile
        }

        return {
            ...profile,
            filters: profile.filters.map((filter) => {
                return {
                    ...filter,
                    key: filter.name,
                    name: i18next.t(`MISC.${filter.name.toUpperCase()}`, filter.name),
                }
            }),
        }
    })
}

export const filterToPayloadKeyMapping = {
    Role: 'role',
    Gender: 'gender',
    'Race/Ethnicity': 'ethnicity',
    'Sexual Orientation': 'sexual_orientation',
    Disability: 'disability_breakdown_simple',
    Levels: 'levels',
    Departments: 'departments',
    Offices: 'offices',
}
